import { type FunctionComponent } from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { FORM_CONTROL_SX, MENU_PROPS } from '@/lib/network-coverage-v2/networkCoverageConstants'
import { type SelectItem } from '@/lib/network-coverage-v2/types'

interface LocationSelectProps {
  label: string
  value: string
  items: SelectItem[]
  onChange: (event: SelectChangeEvent<string>) => void
  iconColor: string
}

const LocationSelect: FunctionComponent<LocationSelectProps> = ({
  label,
  value,
  items,
  onChange,
  iconColor
}) => {
  const labelId = `${(label ?? '').toLowerCase().replace(/\s+/g, '-')}-label`
  return (
    <FormControl sx={FORM_CONTROL_SX} className='w-full'>
      <InputLabel id={labelId} className='w-full text-textHigh'>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        labelId={labelId}
        onChange={onChange}
        className='w-full rounded-lg text-textHigh'
        MenuProps={MENU_PROPS}
        IconComponent={ExpandMoreIcon}
        sx={{ '& .MuiSelect-icon': { color: iconColor } }}
      >
        {items?.map((item) => (
          <MenuItem
            className='bg-surfaceInverse text-textHigh'
            key={item.key}
            value={item.value}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default LocationSelect
